module.exports = __webpack_public_path__ + "img/index6.846a11df.png";